import React, {type ReactNode} from 'react'
import classNames from '@/Utils/ClassNames'

interface ErrorLabelProps {
    error: string | undefined | null
    id?: string
    testId?: string
    className?: string
}

export default function InputErrorLabel(
    {
        error,
        id,
        testId = '',
        className = '',
    }: ErrorLabelProps): ReactNode {
    return (error != null) && (
        <div
            id={id}
            role="alert"
            className={classNames('mt-2 mb-3 text-red-600 dark:text-red-500 text-xs', className)}
            data-testid={testId}
        >{error}</div>
    )
}
